module.exports = {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                enabled: '',
            }), Spark.forms.updateBatchSearchSettings)
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.enabled = this.team.batch_search_enabled;
    },


    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            Spark.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/batch-search`, this.form)
                .then(() => {
                    Bus.$emit('updateTeam');
                });
        }
    }
};
